export const google_client_id = import.meta.env.VITE_GOOGLE_CLIENT_ID;
